<template>
    <div class="container-fluid px-0"
         :style="{ fontSize: FontSizes.normal}"
         :class="{'height-100vh': authUpdateOverlayStateStore.state.show}">
        <div class="row header mx-0">
            <div class="col header-inner">
                <div class="app-title"
                     :style="{fontSize: FontSizes.large2}"
                     @click="onClickAppTitle"
                     :class="{'app-title-clickable': canClickAppTitle()}">アト前払いシステム</div>
                <div v-if="authStore.getters.existsToken"
                     class="login-state">
                    <span>{{ authStore.state.auth.name }}さんがログイン中 </span>
                    <a href="#"
                       @click.prevent.stop="onClickLogout">ログアウト</a>
                </div>
            </div>

        </div>
        <div class="row content-row mx-0">
            <div class="col">
                <div class="router-view-wrap">
                    <router-view/>
                    <LoadingOverlay/>
                </div>
            </div>
        </div>
        <div class="footer row justify-content-center mx-0">
            <div class="col text-center">Ⓒ 株式会社アト 2022</div>
            <button v-if="authStore.getters.existsToken"
                    class="btn btn-outline-light change-pw-button"
                    :style="{fontSize: FontSizes.small1}"
                    @click="onClickChangePassword">認証情報の変更</button>
        </div>
    </div>
    <AuthUpdateOverlay/>
    <ConfirmDialog/>
    <Toast/>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted} from "vue";
import {authStore} from "@/stores/auth-store";
import {useRoute, useRouter} from "vue-router";
import {logoutMessages, subPaths} from "@/utils/consts";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import {loadingOverlayStateStore} from "@/stores/loading-overlay-state-store";
import {useDevice} from "next-vue-device-detector";
import {FontSizes} from "@/utils/font-sizes";
import {authLevels} from "@/data-models/auth";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import Toast from "@/components/Toast.vue";
import AuthUpdateOverlay from "@/components/AuthUpdateOverlay.vue";
import {authUpdateOverlayMode, authUpdateOverlayStateStore} from "@/stores/auth-update-overlay-state-store";
import {toastStore} from "@/stores/toast-store";

export default defineComponent({
    name: "App",
    components: {
        AuthUpdateOverlay,
        Toast,
        ConfirmDialog,
        LoadingOverlay
    },
    setup() {

        const router = useRouter(),
                route = useRoute()

        FontSizes.init(useDevice())

        const onClickLogout = () => {
            authStore.commit("clearAuth")
            authStore.commit("clearToken")
            router.push({
                path: subPaths.LOGGED_OUT,
                query: {
                    logout_message: logoutMessages.NORMAL_LOGOUT.key
                }
            })
        }

        const onClickAppTitle = () => {

            if (!canClickAppTitle()) {
                return
            }

            loadingOverlayStateStore.commit("switchLoadingState", {show: true})
            router.push(subPaths.HOME)
        }

        const canClickAppTitle = (): boolean => {
            // console.log(route.path)
            return ![subPaths.HOME, subPaths.LOGIN, subPaths.LOGGED_OUT].includes(route.path)
                    && authStore.state.auth.authLevel !== authLevels.DIST_STAFF
        }

        const onClickChangePassword = () => {
            authUpdateOverlayStateStore.commit("showOverlay", {
                mode: authUpdateOverlayMode.NORMAL_UPDATE
            })
        }

        // onMounted(() => {
        //     toastStore.commit("post", {
        //         message: `${window.innerWidth} × ${window.innerHeight}`,
        //         keep: true,
        //     })
        // })

        return {
            authStore,
            onClickLogout,
            FontSizes,
            onClickAppTitle,
            canClickAppTitle,
            onClickChangePassword,
            authUpdateOverlayStateStore,
        }
    }
})
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
    //font-size: 1.7vw;
}

.header {
    width: 100%;
    background: orange;
    height: 60px;

    color: white;

    .header-inner {
        position: relative;

        .app-title {
            position: absolute;
            //width: 30vw;
            height: 2.5vw;
            //font-size: 2.5vw;
            left: 1vw;
            top: 0.5vw;

            &-clickable {
                &:hover {
                    opacity: 0.7;
                }

                &:active {
                    opacity: 0.5;
                }
            }
        }

        .login-state {
            //font-size: 1.5vw;
            text-align: right;
            //height: 15px;
            //line-height: 15px;
            height: 1.5vw;
            line-height: 1.5vw;
            position: absolute;
            right: 10px;
            bottom: 5px;
        }
    }
}

.content-row {

    min-height: calc(100vh - 110px);

    .col {
        height: 100%;
        overflow-y: visible;
    }
}

.footer {
    position: relative;
    width: 100%;
    background: orange;
    line-height: 50px;
    color: white;

    .change-pw-button {

        position: absolute;
        height: 30px;
        right: 10px;
        top: 0;
        bottom: 0;
        margin: auto 0;
    }
}
</style>
